export const ClassLevelsEnum = {
  Beginner: 1,
  Intermediate: 2,
  Advanced: 3,
};
